const review = {
  setPhone: ({ state }, payload) => {
    state.review.phone = payload
  },
  setVerificationTicket: ({ state }, payload) => {
    state.review.verificationTicket = payload
  },
  setName: ({ state }, payload) => {
    state.review.name = payload
  },
}

export { review }
